import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import cardPattern from '@assets/card-pattern.png';

export const SurfaceStyled = styled(Box)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  minHeight: 200,
  padding: theme.spacing(2.5),
  color: theme.palette.common.white,
  backgroundImage: `url(${cardPattern}), linear-gradient(210deg, #000000 0%, #3B3B3B 100%)`,
  backgroundRepeat: 'no-repeat, no-repeat',
  backgroundPosition: 'right center, center',
  backgroundSize: 'auto 100%, cover',
  borderRadius: theme.spacing(2),
  boxShadow: theme.shadows[0],
}));
